import axios from "axios";
import { ElMessage } from "element-plus";
// import router from "../router/index.js";

/**
 * @description  本套配置只适用于jwtoken 额外操作请自行配置
 */
const http = axios.create({
    // baseURL: import.meta.env.VITE_APP_API_URL || "/web/api",
    // baseURL: 'https://api.qiuguocloud.com',
});

//过滤器
http.interceptors.request.use(function (config) {
  // config.headers["token"] = Cookies.get('token');
    return config;
}),
    function (err) {
        return Promise.reject(err);
    };

//请求拦截器
http.interceptors.response.use(
    (res) => {
      console.log('axios---', res)
      if (res.data.code === 401 || res.data.code === 400) {
        //登录状态已过期.处理路由重定向
        // localStorage.removeItem("token");
        // router.push("/login");
      }
        return res.data;
    },
    (err) => {
      console.log('err---', err)
        if (err.response && err.response.data) {
            // ElMessage({
            //     showClose: true,
            //     message: err.response.data,
            //     type: "error",
            // });
            // 接口鉴权出错 跳至登录页
            if (err.response.status === 401) {
                // localStorage.removeItem("token");
                // localStorage.removeItem("uid");
                // router.replace("/login");
            }
        }

        return Promise.reject(err);
    }
);

export default http;
